import ENV from "config/Env";
import { backendQueryKey } from "hooks/useTypedQuery";

import type { Customer } from "models";

const component = "CustomerModal";

export const CustomerModalKeys = {
  customerWithServiceDetails: backendQueryKey<Customer>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/customers/service_details" })
};
